import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

import { initReactI18next } from './commonExports';
import { TRANSLATION_RESOURCES } from './resources';
import { DEFAULT_NAMESPACE, DEFAULT_LANGUAGE } from './language';

const isRunningServerSide = typeof window === 'undefined';

export let language = DEFAULT_LANGUAGE;

if (!isRunningServerSide && window['language']) {
  language = window['language'] ?? DEFAULT_LANGUAGE;
}

i18n
  .use(initReactI18next)
  .use(resourcesToBackend((lng: string, ns: string) => import(`../locales/${lng}/${ns}.json`)))
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    fallbackNS: DEFAULT_NAMESPACE,
    interpolation: { escapeValue: false },
    lng: language,
    partialBundledLanguages: true,
    preload: isRunningServerSide ? [DEFAULT_LANGUAGE] : [],
    resources: TRANSLATION_RESOURCES,
  });

export default i18n;
